import { useState, useEffect } from 'react'
import { getIncomeExpFeeTypeAPI } from '../services/in-come'

function UseIncomeEXPFeeType() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const resp = await getIncomeExpFeeTypeAPI()
      if (!resp) return
      if (resp.status) {
        setData(
          resp.result.map((d) => ({ label: d.expFee, value: d.expFeeId }))
        )
      }
    }
    getData()
  }, [])

  return data
}

export default UseIncomeEXPFeeType
